import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import { TopToolbar, ListButton } from "react-admin";

export const MyCreateActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
  </TopToolbar>
);
